module.exports = __webpack_public_path__ + "static/3-d802f76910d7d69e448aaa40d1f0cce7.png";